/* Chiki Toonz theme — shared interactions */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const S = window.ChikiStrings || {};
  const reflow = (el) => void el.offsetWidth;

  /* ---------- Measurement: Chiki moments go to Shopify's customer events as "chiki_<name>" ----------
     A custom pixel (Settings → Customer events) forwards them to Google Analytics; Shopify only sends
     them when the visitor's privacy choices allow it. once() keeps "started playing" to one event per page. */
  const sent = new Set();
  const track = (name, data = {}) => {
    try {
      window.Shopify?.analytics?.publish?.(`chiki_${name}`, { lang: (document.documentElement.lang || '').slice(0, 2), path: location.pathname, ...data });
    } catch (e) { /* measurement never breaks the page */ }
  };
  const once = (key, name, data) => { if (!sent.has(key)) { sent.add(key); track(name, data); } };
  const place = (el) => (el?.closest('section[id], [id^="shopify-section"]')?.id || '').replace(/^shopify-section-.*__/, '');

  /* ---------- Mobile menu ---------- */
  const menuBtn = $('.ck-menu-btn');
  const nav = $('.ck-nav');
  menuBtn?.addEventListener('click', () => {
    const open = nav.classList.toggle('ck-open');
    menuBtn.setAttribute('aria-expanded', open);
  });
  nav?.addEventListener('click', (e) => {
    if (e.target.closest('a')) {
      nav.classList.remove('ck-open');
      menuBtn?.setAttribute('aria-expanded', 'false');
    }
  });

  /* ---------- Navigation: "Ver" and "Aprender" open a small panel (one at a time; Escape or a tap outside closes) ---------- */
  const navTops = $$('.ck-nav-top[aria-controls]');
  const closePanels = (except) => navTops.forEach((b) => { if (b !== except) b.setAttribute('aria-expanded', 'false'); });
  navTops.forEach((btn) => {
    btn.addEventListener('click', () => { const open = btn.getAttribute('aria-expanded') !== 'true'; closePanels(btn); btn.setAttribute('aria-expanded', String(open)); });
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('.ck-nav-group')) closePanels(); });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = navTops.find((b) => b.getAttribute('aria-expanded') === 'true');
    if (open) { closePanels(); open.focus(); }
  });

  /* ---------- Toast ---------- */
  const toast = $('.ck-toast');
  let toastTimer;
  const say = (msg) => {
    if (!toast || !msg) return;
    toast.textContent = msg;
    toast.classList.add('ck-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('ck-on'), 2400);
  };

  /* ---------- Parent gate ---------- */
  const gate = $('.ck-gate');
  let pendingHref = null;
  let lastFocus = null;
  const closeGate = () => {
    if (!gate) return;
    gate.classList.remove('ck-open');
    gate.hidden = true;
    lastFocus?.focus();
  };
  const openGate = (href) => {
    pendingHref = href;
    lastFocus = document.activeElement;
    const a = 3 + Math.floor(Math.random() * 6);
    const b = 3 + Math.floor(Math.random() * 6);
    const right = a * b;
    const opts = new Set([right]);
    while (opts.size < 3) {
      const d = Math.floor(Math.random() * 9) - 4;
      if (d !== 0) opts.add(right + d);
    }
    $('.ck-gate-q', gate).textContent = `${a} × ${b} = ?`;
    $('.ck-gate-dest', gate).textContent = href;
    const box = $('.ck-gate-opts', gate);
    box.innerHTML = '';
    [...opts].sort(() => Math.random() - 0.5).forEach((n) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = n;
      btn.addEventListener('click', () => {
        if (n === right) {
          closeGate();
          window.open(pendingHref, '_blank', 'noopener');
        } else {
          btn.classList.remove('ck-no');
          reflow(btn);
          btn.classList.add('ck-no');
        }
      });
      box.appendChild(btn);
    });
    gate.hidden = false;
    gate.classList.add('ck-open');
    box.querySelector('button').focus();
  };
  $('.ck-gate-close', gate)?.addEventListener('click', closeGate);
  gate?.addEventListener('click', (e) => { if (e.target === gate) closeGate(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && gate?.classList.contains('ck-open')) closeGate(); });
  // Gate explicit [data-ck-gate] links, and any outside link inside the kids' zone.
  const isExternal = (a) => a.host && a.host !== location.host;
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a || !gate || e.defaultPrevented) return;
    const gated = a.hasAttribute('data-ck-gate') || (a.closest('.ck-kidzone') && isExternal(a));
    if (!gated) return;
    e.preventDefault();
    openGate(a.href);
  });

  /* ---------- Hero video: load per viewport, pause toggle ---------- */
  const hero = $('.ck-hero');
  if (hero) {
    const desktop = window.matchMedia('(min-width: 901px)');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const vids = $$('video[data-src]', hero);
    const wanted = (v) => {
      const m = v.dataset.media;
      return m === 'all' || (m === 'desktop' && desktop.matches) || (m === 'mobile' && !desktop.matches);
    };
    const load = () => {
      vids.forEach((v) => {
        if (wanted(v)) {
          const go = () => { if (!reduce.matches && !hero.classList.contains('ck-paused')) v.play().catch(() => {}); };
          if (!v.getAttribute('src')) {
            v.muted = true;
            v.autoplay = !reduce.matches;
            v.addEventListener('canplay', go, { once: true });
            v.src = v.dataset.src;
          }
          go();
        } else if (!v.paused) {
          v.pause();
        }
      });
    };
    load();
    desktop.addEventListener?.('change', load);
    const toggle = $('.ck-hero-toggle', hero);
    toggle?.addEventListener('click', () => {
      const paused = hero.classList.toggle('ck-paused');
      vids.forEach((v) => (paused ? v.pause() : wanted(v) && v.play().catch(() => {})));
      toggle.setAttribute('aria-label', paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
      $('.ck-i-pause', toggle).style.display = paused ? 'none' : '';
      $('.ck-i-resume', toggle).style.display = paused ? '' : 'none';
    });
    if (reduce.matches) {
      hero.classList.add('ck-paused');
      $('.ck-i-pause', toggle || document).style.display = 'none';
      $('.ck-i-resume', toggle || document).style.display = '';
    }
  }

  /* ---------- Scroll reveal ---------- */
  const reveals = $$('.ck-reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) {
          en.target.classList.add('ck-in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('ck-in'));
  }

  /* ---------- Chiki Siluetas ---------- */
  $$('.ck-sil').forEach((game) => {
    const opts = $$('.ck-sil-opts button', game);
    if (!opts.length) return;
    const target = $('.ck-sil-target', game);
    const msg = $('.ck-sil-msg', game);
    const scoreEl = $('[data-score]', game);
    let answer = null, score = 0, last = -1, solved = false;
    const round = () => {
      let i;
      do { i = Math.floor(Math.random() * opts.length); } while (opts.length > 1 && i === last);
      last = i;
      answer = opts[i];
      solved = false;
      game.classList.remove('ck-solved');
      msg.classList.remove('ck-on');
      target.src = answer.dataset.src;
    };
    opts.forEach((b) =>
      b.addEventListener('click', () => {
        if (solved) return;
        if (b === answer) {
          solved = true;
          score += 1;
          scoreEl.textContent = score;
          game.classList.add('ck-solved');
          msg.textContent = game.dataset.right.replace('[name]', b.dataset.name);
          msg.classList.add('ck-on');
          setTimeout(round, 2200);
        } else {
          b.classList.remove('ck-no');
          reflow(b);
          b.classList.add('ck-no');
          msg.textContent = game.dataset.wrong;
          msg.classList.add('ck-on');
        }
      })
    );
    $('[data-next]', game)?.addEventListener('click', round);
    round();
  });

  /* ---------- Add to cart (uses Dawn's cart drawer when present) ---------- */
  const bumpBubble = () => {
    const c = $('#cart-icon-bubble .ck-cart-count');
    if (!c) return;
    c.classList.remove('ck-bump');
    reflow(c);
    c.classList.add('ck-bump');
  };
  // When /cart/add.js answers without the rendered sections, fetch them (Section Rendering API, from the site root)
  const cartSections = async (drawer) => {
    try {
      const ids = drawer ? drawer.getSectionsToRender().map((x) => x.id) : ['cart-icon-bubble'];
      const r = await fetch(`${window.Shopify?.routes?.root || '/'}?sections=${ids.join(',')}`, { headers: { Accept: 'application/json' } });
      return r.ok ? await r.json() : null;
    } catch (err) { return null; }
  };
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('button.ck-add[data-variant-id]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    const drawer = document.querySelector('cart-drawer');
    const body = new FormData();
    body.append('id', btn.dataset.variantId);
    body.append('quantity', 1);
    const sections = drawer ? drawer.getSectionsToRender().map((s) => s.id) : ['cart-icon-bubble'];
    body.append('sections', sections);
    body.append('sections_url', window.Shopify?.routes?.root || '/'); // the root always renders sections; /collections/all does not
    try {
      const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body,
      });
      const json = await res.json();
      if (json.status) throw new Error(json.description || json.message);
      if (!json.sections) json.sections = await cartSections(drawer);
      if (drawer && json.sections) {
        drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
        drawer.renderContents(json);
      } else if (json.sections?.['cart-icon-bubble']) {
        const html = new DOMParser().parseFromString(json.sections['cart-icon-bubble'], 'text/html');
        const inner = html.querySelector('.shopify-section');
        if (inner) $('#cart-icon-bubble').innerHTML = inner.innerHTML;
      }
      bumpBubble();
      btn.classList.add('ck-ok');
      setTimeout(() => btn.classList.remove('ck-ok'), 900);
      const pick = btn.closest('details.ck-win-pick');
      if (pick) setTimeout(() => { pick.open = false; }, 700);
      if (!drawer || !json.sections) say(S.added);
    } catch (err) {
      say(err?.message || S.addError);
    } finally {
      btn.disabled = false;
    }
  });

  /* ---------- Video rail filters ---------- */
  $$('.ck-rail-filters').forEach((bar) => {
    const rail = bar.parentElement.querySelector('.ck-rail');
    $$('.ck-chip', bar).forEach((chip) =>
      chip.addEventListener('click', () => {
        $$('.ck-chip', bar).forEach((c) => c.setAttribute('aria-pressed', c === chip));
        const f = chip.dataset.filter;
        $$('.ck-video', rail).forEach((v) => (v.hidden = f !== 'all' && v.dataset.show !== f));
      })
    );
  });

  /* ---------- Memory game ---------- */
  $$('.ck-memory').forEach((game) => {
    const grid = $('.ck-memory-grid', game);
    const deck = [...$('.ck-memory-deck', game).content.children];
    if (!deck.length) return;
    const movesEl = $('[data-moves]', game);
    const pairsEl = $('[data-pairs]', game);
    const win = $('.ck-memory-win', game);
    let first = null, lock = false, moves = 0, found = 0;

    const deal = () => {
      moves = 0; found = 0; first = null; lock = false;
      movesEl.textContent = 0;
      pairsEl.textContent = `0/${deck.length}`;
      win.classList.remove('ck-on');
      grid.innerHTML = '';
      [...deck, ...deck]
        .map((d) => ({ d, id: deck.indexOf(d), r: Math.random() }))
        .sort((a, b) => a.r - b.r)
        .forEach(({ d, id }) => {
          const b = document.createElement('button');
          b.className = 'ck-mcard';
          b.type = 'button';
          b.dataset.id = id;
          b.style.setProperty('--c', d.dataset.c);
          b.setAttribute('aria-label', S.hiddenCard || '?');
          b.innerHTML = `<div class="ck-mcard-inner"><div class="ck-mcard-face ck-mcard-back"></div><div class="ck-mcard-face ck-mcard-front"></div></div>`;
          const img = d.querySelector('img').cloneNode(true);
          img.loading = 'eager';
          b.querySelector('.ck-mcard-front').appendChild(img);
          b.addEventListener('click', () => flip(b, d.dataset.name));
          grid.appendChild(b);
        });
    };

    const flip = (b, name) => {
      if (lock || b === first || b.classList.contains('ck-done')) return;
      b.classList.add('ck-flip');
      b.setAttribute('aria-label', name);
      if (!first) { first = b; return; }
      moves += 1;
      movesEl.textContent = moves;
      if (first.dataset.id === b.dataset.id) {
        first.classList.add('ck-done');
        b.classList.add('ck-done');
        first = null;
        found += 1;
        pairsEl.textContent = `${found}/${deck.length}`;
        if (found === deck.length) {
          win.textContent = (S.win || '🌈 [moves]').replace('[moves]', moves);
          win.classList.add('ck-on');
        }
      } else {
        lock = true;
        const a = first;
        first = null;
        setTimeout(() => {
          [a, b].forEach((c) => {
            c.classList.remove('ck-flip');
            c.setAttribute('aria-label', S.hiddenCard || '?');
          });
          lock = false;
        }, 850);
      }
    };

    $('[data-reset]', game).addEventListener('click', deal);
    deal();
  });

  /* ---------- Tooniez profile switcher ---------- */
  const profile = $('.ck-tz-profile');
  if (profile) {
    const cards = $$('.ck-toonie-card');
    const show = (card, animate = true) => {
      cards.forEach((c) => c.setAttribute('aria-pressed', c === card));
      const d = card.dataset;
      profile.style.setProperty('--c', d.c);
      const img = $('img', profile);
      img.src = d.img;
      img.alt = d.name;
      $('h3', profile).textContent = d.name;
      $('.ck-power', profile).textContent = d.power;
      $('.ck-bio', profile).textContent = d.bio;
      const ul = $('ul', profile);
      ul.innerHTML = '';
      d.likes.split('|').forEach((l) => {
        const li = document.createElement('li');
        li.textContent = l;
        ul.appendChild(li);
      });
      if (animate) {
        profile.classList.remove('ck-swap');
        reflow(profile);
        profile.classList.add('ck-swap');
      }
    };
    cards.forEach((c) =>
      c.addEventListener('click', () => {
        show(c);
        profile.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      })
    );
    if (cards.length) show(cards[0], false);
  }

  /* ---------- Event registration form ---------- */
  const evSelect = $('[data-event-select]');
  if (evSelect) {
    const timeField = $('[data-time-field]');
    const timeSelect = $('[data-time-select]');
    const syncTimes = () => {
      const opt = evSelect.selectedOptions[0];
      const times = (opt?.dataset.times || '').split(',').map((t) => t.trim()).filter(Boolean);
      timeSelect.innerHTML = '<option value="">—</option>' + times.map((t) => `<option>${t}</option>`).join('');
      timeField.hidden = times.length === 0;
      timeSelect.required = times.length > 0;
    };
    const pick = (slug) => {
      const opt = [...evSelect.options].find((o) => o.dataset.slug === slug);
      if (opt) { evSelect.value = opt.value; syncTimes(); }
    };
    evSelect.addEventListener('change', syncTimes);
    $$('[data-pick-event]').forEach((a) => a.addEventListener('click', () => pick(a.dataset.pickEvent)));
    const wanted = new URLSearchParams(location.search).get('evento');
    if (wanted) pick(wanted);
    syncTimes();
    const other = $('[data-other-input]');
    $$('input[type=radio][name^="contact[¿Cómo"]').forEach((r) =>
      r.addEventListener('change', () => {
        const on = r.hasAttribute('data-other') && r.checked;
        other.hidden = !on;
        other.required = on;
        if (on) other.focus();
      })
    );
  }

  /* ---------- On-site video player (privacy-enhanced YouTube) ---------- */
  const vmodal = $('.ck-vmodal');
  if (vmodal) {
    const frame = $('.ck-vmodal-frame', vmodal);
    const title = $('.ck-vmodal-title', vmodal);
    const lang = (document.documentElement.lang || 'es').slice(0, 2);
    let opener = null;
    const close = () => {
      frame.innerHTML = '';
      vmodal.hidden = true;
      document.documentElement.classList.remove('ck-noscroll');
      opener?.focus();
    };
    const open = ({ id, list, name, start }) => {
      opener = document.activeElement;
      const base = 'https://www.youtube-nocookie.com/embed/';
      const params = `autoplay=1&rel=0&modestbranding=1&playsinline=1&hl=${lang}&cc_lang_pref=${lang}${start > 0 ? `&start=${Math.floor(start)}` : ''}`;
      const src = list ? `${base}videoseries?list=${list}&${params}` : `${base}${id}?${params}`;
      frame.innerHTML = `<iframe src="${src}" title="${(name || 'Chiki TV').replace(/"/g, '&quot;')}" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen referrerpolicy="strict-origin-when-cross-origin"></iframe>`;
      title.textContent = name || '';
      vmodal.hidden = false;
      document.documentElement.classList.add('ck-noscroll');
      $('.ck-vmodal-close', vmodal).focus();
    };
    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-ck-video], [data-ck-list]');
      if (!t) return;
      e.preventDefault();
      open({ id: t.dataset.ckVideo, list: t.dataset.ckList, name: t.dataset.title || t.getAttribute('aria-label') || '', start: parseFloat(t.dataset.start) || 0 });
    });
    $('.ck-vmodal-close', vmodal).addEventListener('click', close);
    vmodal.addEventListener('click', (e) => { if (e.target === vmodal) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !vmodal.hidden) close(); });
    // Deep link: ?v=ID opens the video (e.g. from the homepage or a shared link)
    const deep = new URLSearchParams(location.search).get('v');
    if (deep && /^[\w-]{11}$/.test(deep)) {
      const card = $(`[data-ck-video="${deep}"]`);
      open({ id: deep, name: card?.dataset.title || '' });
    }
  }

  /* ---------- Chiki TV hub: filters + search ---------- */
  $$('.ck-hub').forEach((hub) => {
    const cards = $$('.ck-hub-card', hub);
    const count = $('[data-hub-count]', hub);
    const empty = $('.ck-hub-empty', hub);
    const search = $('.ck-hub-search input', hub);
    const state = { topic: 'all', age: 'all', value: 'all', q: '' };
    const norm = (s) => s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const apply = () => {
      let n = 0;
      cards.forEach((c) => {
        const ok = ['topic', 'age', 'value'].every((k) => state[k] === 'all' || (c.dataset[k] || '').split(' ').includes(state[k]))
          && (!state.q || norm(c.dataset.title).includes(state.q));
        c.hidden = !ok;
        if (ok) n += 1;
      });
      count.textContent = n;
      empty.hidden = n > 0;
    };
    $$('.ck-hub-filters [data-group]', hub).forEach((group) => {
      $$('.ck-chip', group).forEach((chip) =>
        chip.addEventListener('click', () => {
          $$('.ck-chip', group).forEach((c) => c.setAttribute('aria-pressed', c === chip));
          state[group.dataset.group] = chip.dataset.val;
          apply();
        })
      );
    });
    search?.addEventListener('input', () => { state.q = norm(search.value.trim()); apply(); });
    $('[data-hub-clear]', hub)?.addEventListener('click', () => {
      Object.assign(state, { topic: 'all', age: 'all', value: 'all', q: '' });
      if (search) search.value = '';
      $$('.ck-hub-filters .ck-chip', hub).forEach((c) => c.setAttribute('aria-pressed', c.dataset.val === 'all'));
      apply();
    });
    apply();
  });

  /* ---------- Diorama: fit the stage under the header (the header scrolls, so measure once per resize) ---------- */
  const dioEl = $('[data-dio]');
  if (dioEl) {
    const fit = () => dioEl.style.setProperty('--ck-dio-top', Math.max(0, Math.round(dioEl.getBoundingClientRect().top + scrollY)) + 'px');
    fit();
    addEventListener('resize', fit, { passive: true });
  }

  /* ---------- Diorama: Tooniez say hi (works with or without motion) ---------- */
  $$('.ck-dio-toonie').forEach((t) => {
    const bubble = $('.ck-dio-bubble', t);
    let timer;
    t.addEventListener('click', () => {
      bubble.textContent = t.dataset.hi;
      t.classList.add('ck-talk');
      clearTimeout(timer);
      timer = setTimeout(() => t.classList.remove('ck-talk'), 1800);
    });
  });

  /* ---------- Video rails: arrow buttons on desktop (touch users swipe) ---------- */
  $$('.ck-rail').forEach((rail) => {
    const wrap = document.createElement('div');
    wrap.className = 'ck-rail-wrap';
    rail.before(wrap);
    wrap.append(rail);
    const mk = (dir) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = `ck-rail-arrow ck-rail-arrow--${dir}`;
      b.setAttribute('aria-label', dir === 'prev' ? S.prev || 'Anterior' : S.next || 'Siguiente');
      b.innerHTML = '<svg aria-hidden="true" width="22" height="22"><use href="#ck-i-arrow"/></svg>';
      b.addEventListener('click', () => rail.scrollBy({ left: (dir === 'prev' ? -1 : 1) * rail.clientWidth * 0.85, behavior: 'smooth' }));
      wrap.append(b);
      return b;
    };
    const prev = mk('prev');
    const next = mk('next');
    const sync = () => {
      const max = rail.scrollWidth - rail.clientWidth - 4;
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft >= max;
      wrap.classList.toggle('ck-rail-static', max <= 0);
    };
    rail.addEventListener('scroll', sync, { passive: true });
    addEventListener('resize', sync, { passive: true });
    sync();
  });

  /* ---------- Tour: live countdown to the next show ---------- */
  $$('[data-ck-countdown]').forEach((el) => {
    const target = new Date(el.dataset.ckCountdown).getTime();
    if (Number.isNaN(target)) return;
    const out = { d: $('[data-u="d"]', el), h: $('[data-u="h"]', el), m: $('[data-u="m"]', el), s: $('[data-u="s"]', el) };
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const left = target - Date.now();
      if (left <= 0) {
        el.innerHTML = `<p class="ck-cd-today">${el.dataset.today}</p>`;
        return;
      }
      out.d.textContent = Math.floor(left / 864e5);
      out.h.textContent = pad(Math.floor(left / 36e5) % 24);
      out.m.textContent = pad(Math.floor(left / 6e4) % 60);
      out.s.textContent = pad(Math.floor(left / 1e3) % 60);
      setTimeout(tick, 1000);
    };
    tick();
  });

  /* ---------- Tour: "add to my calendar" (.ics built in the browser, no third party) ---------- */
  $$('[data-ck-ics]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const start = new Date(btn.dataset.start);
      const end = new Date(start.getTime() + 2 * 36e5);
      const stamp = (d) => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
      const esc = (t) => String(t || '').replace(/([,;\\])/g, '\\$1');
      const ics = [
        'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Chiki Toonz//Tour//ES', 'BEGIN:VEVENT',
        `UID:${stamp(start)}-${Math.random().toString(36).slice(2)}@chikitoonz.com`,
        `DTSTAMP:${stamp(new Date())}`,
        ...(btn.hasAttribute('data-allday')
          ? [`DTSTART;VALUE=DATE:${btn.dataset.date}`, `DTEND;VALUE=DATE:${stamp(new Date(start.getTime() + 864e5)).slice(0, 8)}`]
          : [`DTSTART:${stamp(start)}`, `DTEND:${stamp(end)}`]),
        `SUMMARY:${esc(btn.dataset.title)}`, `LOCATION:${esc(btn.dataset.place)}`,
        btn.dataset.url ? `URL:${btn.dataset.url}` : '', 'END:VEVENT', 'END:VCALENDAR',
      ].filter(Boolean).join('\r\n');
      const a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([ics], { type: 'text/calendar' }));
      a.download = btn.dataset.file || 'chiki-toonz.ics';
      document.body.append(a);
      a.click();
      setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
    });
  });

  /* ---------- Sticker board (Chiki Stickers) ---------- */
  $$('[data-ck-stickers]').forEach((root) => {
    const stage = $('[data-stage]', root);
    const bg = $('[data-bg]', root);
    const tools = $('[data-tools]', root);
    const empty = $('[data-empty]', root);
    const KEY = 'ck-stickers-v1';
    let items = [];
    let sel = null;
    let z = 1;
    let audio;

    const pop = () => {
      try {
        audio = audio || new (window.AudioContext || window.webkitAudioContext)();
        const o = audio.createOscillator();
        const g = audio.createGain();
        o.type = 'sine';
        o.frequency.setValueAtTime(520, audio.currentTime);
        o.frequency.exponentialRampToValueAtTime(980, audio.currentTime + 0.09);
        g.gain.setValueAtTime(0.12, audio.currentTime);
        g.gain.exponentialRampToValueAtTime(0.001, audio.currentTime + 0.16);
        o.connect(g).connect(audio.destination);
        o.start();
        o.stop(audio.currentTime + 0.17);
      } catch (e) { /* sound is optional */ }
    };
    const save = () => {
      try {
        localStorage.setItem(KEY, JSON.stringify({ bg: bg.dataset.sceneId || bg.getAttribute('src'), items: items.map(({ el, ...d }) => d) }));
      } catch (e) { /* storage may be blocked */ }
    };
    const paint = (it) => {
      it.el.style.cssText = `left:${it.x}%;top:${it.y}%;width:${it.w}%;z-index:${it.z};transform:translate(-50%,-50%) rotate(${it.r}deg) scaleX(${it.f ? -1 : 1})`;
    };
    const select = (it) => {
      sel = it;
      items.forEach((o) => o.el.classList.toggle('is-sel', o === it));
      tools.classList.toggle('is-on', !!it);
    };
    const add = (src, d = {}) => {
      const it = { src, x: d.x ?? 40 + Math.random() * 20, y: d.y ?? 40 + Math.random() * 20, w: d.w ?? 16, r: d.r ?? (Math.random() * 16 - 8), f: d.f ?? false, z: d.z ?? ++z };
      z = Math.max(z, it.z);
      const el = document.createElement('button');
      el.type = 'button';
      el.className = 'ck-stk-item';
      el.setAttribute('aria-label', 'Sticker');
      el.innerHTML = `<img src="${src}" alt="" draggable="false">`;
      it.el = el;
      stage.append(el);
      paint(it);
      items.push(it);
      empty.hidden = true;
      let start = null;
      el.addEventListener('pointerdown', (e) => {
        e.preventDefault();
        try { el.setPointerCapture(e.pointerId); } catch (err) { /* capture is a nicety */ }
        select(it);
        const r = stage.getBoundingClientRect();
        start = { px: e.clientX, py: e.clientY, x: it.x, y: it.y, rw: r.width, rh: r.height };
        el.classList.add('is-drag');
      });
      el.addEventListener('pointermove', (e) => {
        if (!start) return;
        it.x = Math.min(100, Math.max(0, start.x + ((e.clientX - start.px) / start.rw) * 100));
        it.y = Math.min(100, Math.max(0, start.y + ((e.clientY - start.py) / start.rh) * 100));
        paint(it);
      });
      const end = () => { if (start) { start = null; el.classList.remove('is-drag'); save(); } };
      el.addEventListener('pointerup', end);
      el.addEventListener('pointercancel', end);
      el.addEventListener('focus', () => select(it));
      el.addEventListener('keydown', (e) => {
        const step = e.shiftKey ? 5 : 1;
        const map = { ArrowLeft: () => (it.x -= step), ArrowRight: () => (it.x += step), ArrowUp: () => (it.y -= step), ArrowDown: () => (it.y += step), '+': () => act('bigger'), '=': () => act('bigger'), '-': () => act('smaller'), r: () => act('rotr'), R: () => act('rotl'), f: () => act('flip') };
        if (e.key === 'Delete' || e.key === 'Backspace') { e.preventDefault(); act('del'); return; }
        if (map[e.key]) { e.preventDefault(); map[e.key](); paint(it); save(); }
      });
      return it;
    };
    const act = (a) => {
      if (!sel) return;
      const it = sel;
      if (a === 'bigger') it.w = Math.min(60, it.w * 1.18);
      if (a === 'smaller') it.w = Math.max(5, it.w / 1.18);
      if (a === 'rotl') it.r -= 15;
      if (a === 'rotr') it.r += 15;
      if (a === 'flip') it.f = !it.f;
      if (a === 'front') it.z = ++z;
      if (a === 'del') {
        it.el.remove();
        items = items.filter((o) => o !== it);
        select(null);
        empty.hidden = items.length > 0;
        save();
        return;
      }
      paint(it);
      save();
    };

    $$('[data-act]', tools).forEach((b) => b.addEventListener('click', () => act(b.dataset.act)));
    $$('[data-sticker]', root).forEach((b) => b.addEventListener('click', () => {
      once(`stickers-${place(root)}`, 'stickers_play', { place: place(root) });
      const it = add(b.dataset.sticker);
      select(it);
      pop();
      it.el.animate?.([{ transform: `${it.el.style.transform} scale(.2)` }, { transform: it.el.style.transform }], { duration: 320, easing: 'cubic-bezier(.34,1.56,.64,1)' });
      save();
    }));
    const scenes = $$('[data-scene]', root);
    const setScene = (src) => {
      bg.src = src;
      scenes.forEach((b) => b.setAttribute('aria-checked', String(b.dataset.scene === src)));
    };
    scenes.forEach((b) => b.addEventListener('click', () => { setScene(b.dataset.scene); save(); }));
    stage.addEventListener('pointerdown', (e) => { if (e.target === stage || e.target === bg) select(null); });
    $('[data-clear]', root)?.addEventListener('click', () => {
      items.forEach((it) => it.el.remove());
      items = [];
      select(null);
      empty.hidden = false;
      save();
    });

    // Save as a 1600×900 PNG, drawn the same way the stage shows it (background "cover", stickers on top)
    $('[data-save]', root)?.addEventListener('click', async () => {
      select(null);
      const W = 1600;
      const H = 900;
      const c = document.createElement('canvas');
      c.width = W;
      c.height = H;
      const ctx = c.getContext('2d');
      const load = (src) => new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = src; });
      try {
        const b = await load(bg.src);
        const s = Math.max(W / b.naturalWidth, H / b.naturalHeight);
        ctx.drawImage(b, (W - b.naturalWidth * s) / 2, (H - b.naturalHeight * s) / 2, b.naturalWidth * s, b.naturalHeight * s);
        for (const it of [...items].sort((a, b2) => a.z - b2.z)) {
          const im = await load(it.src);
          const w = (it.w / 100) * W;
          const h = w * (im.naturalHeight / im.naturalWidth);
          ctx.save();
          ctx.translate((it.x / 100) * W, (it.y / 100) * H);
          ctx.rotate((it.r * Math.PI) / 180);
          ctx.scale(it.f ? -1 : 1, 1);
          ctx.drawImage(im, -w / 2, -h / 2, w, h);
          ctx.restore();
        }
        const a = document.createElement('a');
        a.download = `${root.dataset.file || 'chiki-town'}.png`;
        a.href = c.toDataURL('image/png');
        document.body.append(a);
        a.click();
        a.remove();
      } catch (e) {
        say(S.addError);
      }
    });

    // Restore the last picture on this device
    try {
      const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (saved) {
        if (saved.bg && scenes.some((b) => b.dataset.scene === saved.bg)) setScene(saved.bg);
        (saved.items || []).forEach((d) => add(d.src, d));
        select(null);
      }
    } catch (e) { /* start fresh */ }

    // Homepage mini board: nothing saved yet → two stickers wait on the scene with a "drag me" hint
    if (!items.length && root.dataset.starter) {
      const seed = () => {
        if (items.length) return;
        root.dataset.starter.split(';').filter(Boolean).forEach((row, i) => {
          const [src, x, y, w] = row.split('|');
          const it = add(src, { x: +x || 50, y: +y || 60, w: +w || 18, r: i % 2 ? 6 : -6 });
          it.el.classList.add('is-hint');
        });
        select(null);
        empty.hidden = false;
        const done = () => { empty.hidden = true; items.forEach((it) => it.el.classList.remove('is-hint')); stage.removeEventListener('pointerdown', done); };
        stage.addEventListener('pointerdown', done);
      };
      // The board sits far down the homepage: only fetch its starter stickers when it is about to scroll into view
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(([en]) => { if (en.isIntersecting) { io.disconnect(); seed(); } }, { rootMargin: '400px 0px' });
        io.observe(root);
      } else seed();
    }
  });

  /* ---------- Canta y Aprende: sing-along lyrics player ---------- */
  $$('[data-ck-cya]').forEach(async (root) => {
    const team = new URLSearchParams(location.search).has('sincronizar');
    const lang = root.dataset.lang;
    const trCol = lang === 'pt' ? 3 : 2; // es & en pages show English, pt pages show Portuguese
    const introCol = lang === 'pt' ? 2 : lang === 'en' ? 1 : 0;
    const vocabCol = lang === 'pt' ? 2 : 1;
    const els = {
      songs: $('[data-songs]', root), lines: $('[data-lines]', root), thumb: $('[data-thumb]', root), start: $('[data-start]', root),
      yt: $('[data-yt]', root), intro: $('[data-intro]', root), vocab: $('[data-vocab]', root), vocabWrap: $('[data-vocab-wrap]', root),
      tr: $('[data-tr]', root), slow: $('[data-slow]', root), loop: $('[data-loop]', root),
    };
    let data;
    try { data = await (await fetch(root.dataset.src)).json(); } catch (e) { return; }
    const songs = data.songs.filter((s) => team || s.timed);
    let song = null;
    let player = null;
    let active = -1;
    let loopLine = -1;
    let timer = null;
    let showTr = root.dataset.trDefault === 'on';
    try { const v = localStorage.getItem('ck-cya-tr'); if (v) showTr = v === 'on'; } catch (e) { /* default */ }

    const setToggle = (b, on) => b.setAttribute('aria-pressed', String(on));
    const applyTr = () => { root.classList.toggle('ck-cya--tr', showTr); setToggle(els.tr, showTr); };
    applyTr();

    // Song chips
    songs.forEach((s, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.style.setProperty('--c', s.color);
      b.innerHTML = `<img src="${root.dataset.assets}${s.sticker}" alt="" width="56" height="56"><span>${s.title}</span>${team && !s.timed ? '<small>sin tiempos</small>' : ''}`;
      b.addEventListener('click', () => pick(i, true));
      els.songs.append(b);
    });

    const renderLines = () => {
      els.lines.innerHTML = '';
      song.lines.forEach((ln, i) => {
        const li = document.createElement('li');
        if (ln[4]) li.classList.add('ck-gap');
        li.innerHTML = `<button type="button" data-i="${i}"><span class="ck-es">${ln[1]}</span>${ln[trCol] ? `<span class="ck-tr" lang="${lang === 'pt' ? 'pt' : 'en'}">${ln[trCol]}</span>` : ''}</button>`;
        els.lines.append(li);
      });
    };
    const pick = (i, userAction) => {
      song = songs[i];
      root.style.setProperty('--song', song.color);
      $$('[role=tab]', els.songs).forEach((b, j) => b.setAttribute('aria-selected', String(j === i)));
      els.thumb.src = `https://i.ytimg.com/vi/${song.video}/hqdefault.jpg`;
      els.intro.textContent = song.intro[introCol] || '';
      els.vocab.innerHTML = song.vocab.map((v) => `<li><span aria-hidden="true">${v[3]}</span><b lang="es">${v[0]}</b><small>${v[vocabCol]}</small></li>`).join('');
      els.vocabWrap.hidden = !song.vocab.length;
      active = -1;
      loopLine = -1;
      setToggle(els.loop, false);
      renderLines();
      if (player && player.loadVideoById) player.loadVideoById(song.video);
      else if (userAction && player) player.cueVideoById?.(song.video);
      sync.reset?.();
    };

    // YouTube player (privacy-enhanced), created on the first play
    const loadApi = () => new Promise((res) => {
      if (window.YT && window.YT.Player) return res();
      const prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => { prev?.(); res(); };
      const s = document.createElement('script');
      s.src = 'https://www.youtube.com/iframe_api';
      document.head.append(s);
    });
    const start = async () => {
      els.start.classList.add('is-loading');
      await loadApi();
      player = new YT.Player(els.yt, {
        host: 'https://www.youtube-nocookie.com',
        videoId: song.video,
        playerVars: { autoplay: 1, rel: 0, modestbranding: 1, playsinline: 1, hl: lang },
        events: {
          onReady: (e) => { els.start.hidden = true; e.target.playVideo(); },
          onStateChange: (e) => { if (e.data === 1) tick(); },
        },
      });
    };
    els.start.addEventListener('click', start);

    const setActive = (i) => {
      if (i === active) return;
      active = i;
      $$('li', els.lines).forEach((li, j) => { li.classList.toggle('is-on', j === i); li.classList.toggle('is-past', j < i); });
      const li = els.lines.children[i];
      if (li) {
        const box = els.lines.parentElement;
        box.scrollTo({ top: li.offsetTop - box.clientHeight / 3, behavior: 'smooth' });
      }
    };
    const tick = () => {
      clearTimeout(timer);
      if (!player || !player.getCurrentTime) return;
      const t = player.getCurrentTime();
      if (song.timed) {
        let i = -1;
        for (let j = 0; j < song.lines.length; j += 1) { if (song.lines[j][0] !== null && song.lines[j][0] <= t) i = j; }
        if (loopLine >= 0) {
          const end = song.lines[loopLine + 1]?.[0] ?? song.lines[loopLine][0] + 4;
          if (t >= end || t < song.lines[loopLine][0] - 0.5) player.seekTo(song.lines[loopLine][0], true);
        }
        setActive(i);
      }
      if (player.getPlayerState?.() === 1) timer = setTimeout(tick, 120);
    };

    // Tap a line: jump there (and start the player if needed)
    els.lines.addEventListener('click', async (e) => {
      const b = e.target.closest('button[data-i]');
      if (!b || !song.timed) return;
      const i = +b.dataset.i;
      if (!player) { await start(); const wait = () => (player.seekTo ? player.seekTo(song.lines[i][0], true) : setTimeout(wait, 200)); wait(); return; }
      player.seekTo(song.lines[i][0], true);
      player.playVideo();
      if (loopLine >= 0) loopLine = i;
    });

    els.tr.addEventListener('click', () => { showTr = !showTr; applyTr(); try { localStorage.setItem('ck-cya-tr', showTr ? 'on' : 'off'); } catch (e) { /* ok */ } });
    els.slow.addEventListener('click', () => {
      const on = els.slow.getAttribute('aria-pressed') !== 'true';
      setToggle(els.slow, on);
      player?.setPlaybackRate?.(on ? 0.75 : 1);
    });
    els.loop.addEventListener('click', () => {
      const on = loopLine < 0;
      loopLine = on ? Math.max(0, active) : -1;
      setToggle(els.loop, on);
    });

    // Team timing mode (?sincronizar=1): tap once per line while the song plays, then copy the times
    const sync = {};
    if (team) {
      const box = $('[data-sync]', root);
      box.hidden = false;
      const status = $('[data-sync-status]', box);
      let rec = false;
      let stamps = [];
      const show = () => { status.textContent = `${stamps.length} / ${song.lines.length}`; setActive(stamps.length - 1); };
      sync.reset = () => { rec = false; stamps = []; status.textContent = ''; };
      const stamp = () => {
        if (!rec || !player?.getCurrentTime || stamps.length >= song.lines.length) return;
        stamps.push(Math.round(player.getCurrentTime() * 100) / 100);
        show();
      };
      $('[data-sync-rec]', box).addEventListener('click', async () => {
        stamps = [];
        rec = true;
        if (!player) await start(); else { player.seekTo(0, true); player.playVideo(); }
        show();
      });
      $('[data-sync-tap]', box).addEventListener('click', stamp);
      document.addEventListener('keydown', (e) => { if (rec && e.code === 'Space' && !e.target.closest('input,textarea')) { e.preventDefault(); stamp(); } });
      $('[data-sync-undo]', box).addEventListener('click', () => { stamps.pop(); show(); });
      $('[data-sync-copy]', box).addEventListener('click', async () => {
        const txt = JSON.stringify({ [song.key]: stamps });
        try { await navigator.clipboard.writeText(txt); status.textContent = '✓ Copiado'; } catch (e) { prompt('Copia estos tiempos:', txt); }
      });
    }

    const wanted = songs.findIndex((s) => s.key === new URLSearchParams(location.search).get('cancion'));
    pick(Math.max(0, wanted), false);
  });

  /* ---------- Reel: live-action loop, loads near the viewport; 360p on phones / Save-Data ---------- */
  $$('[data-ck-reel]').forEach((sec) => {
    const v = $('video', sec);
    const btn = $('[data-reel-toggle]', sec);
    if (!v) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const small = window.matchMedia('(max-width: 700px)').matches || navigator.connection?.saveData;
    let userPaused = reduce, visible = false;
    const setBtn = () => {
      btn.setAttribute('aria-pressed', String(userPaused));
      btn.setAttribute('aria-label', userPaused ? btn.dataset.labelPlay : btn.dataset.labelPause);
    };
    const sync = () => {
      if (!userPaused && visible) {
        if (!v.getAttribute('src')) { v.muted = true; v.src = small ? v.dataset.srcSm : v.dataset.srcLg; }
        v.play().catch(() => {});
      } else v.pause();
    };
    setBtn();
    btn.addEventListener('click', () => { userPaused = !userPaused; setBtn(); sync(); });
    new IntersectionObserver(([en]) => { visible = en.isIntersecting; sync(); }, { rootMargin: '200px 0px' }).observe(v);
  });

  /* ---------- Un día en Chiki Town: the clock tower shows the visitor's real time ---------- */
  const towerClock = $('[data-dio-clock]');
  if (towerClock) {
    const hand = { h: $('.h', towerClock), m: $('.m', towerClock) };
    const deg = { h: 305, m: 60 }; // the pose painted in the art (10:10); hands always turn forward from here
    const turn = (k, target, intro) => { let d = ((target - deg[k]) % 360 + 360) % 360; if (intro && k === 'm') d += 360; if (!d) return; deg[k] += d; hand[k].style.setProperty('--r', `${deg[k]}deg`); };
    const now = () => {
      const forced = new URLSearchParams(location.search).get('hora');
      if (forced && !isNaN(parseFloat(forced))) { const f = parseFloat(forced); return [Math.floor(f), Math.round((f % 1) * 60)]; }
      const d = new Date(); return [d.getHours(), d.getMinutes()];
    };
    const set = (intro) => { const [h, m] = now(); turn('h', (h % 12) * 30 + m * 0.5, intro); turn('m', m * 6, intro); };
    setTimeout(() => set(true), 900); // one friendly spin from the painted 10:10 to the real time
    setInterval(() => set(false), 30000);
  }

  /* ---------- Day clock: scrolling the homepage is one day in Chiki Town, 7:00 → 22:00 ---------- */
  const dayClock = $('[data-dayclock]');
  if (dayClock) {
    const btn = $('.ck-dayclock-btn', dayClock), menu = $('#ck-daymenu'), list = $('[data-dc-list]', dayClock), label = $('[data-dc-time]', dayClock);
    const hH = $('.h', btn), hM = $('.m', btn);
    const hero = $('.ck-dio');
    const START = 7, SPAN = 15;
    const fmt = (h) => { const m = Math.round(h * 12) * 5; return `${Math.floor(m / 60)}:${String(m % 60).padStart(2, '0')}`; };
    const partOf = (h) => (h < 7.5 ? 'dawn' : h < 17.5 ? 'day' : h < 20 ? 'dusk' : 'night');
    // Chapters that state their hour (data-hour-anchor="9:00") pin the clock; the rest of the day is interpolated between them
    const toH = (t) => { const [h, m] = String(t).split(':'); return (+h || 0) + (+m || 0) / 60; };
    const anchors = () => {
      const max = document.documentElement.scrollHeight - innerHeight;
      const pts = $$('[data-hour-anchor]').map((el) => ({ y: Math.max(0, el.getBoundingClientRect().top + scrollY - innerHeight * 0.35), h: toH(el.dataset.hourAnchor) })).filter((p) => p.h > START && p.h < START + SPAN && p.y < max);
      return [{ y: 0, h: START }, ...pts.sort((a, b) => a.y - b.y), { y: Math.max(max, 1), h: START + SPAN }];
    };
    let pts = anchors();
    const hourAt = (y) => {
      for (let i = 1; i < pts.length; i++) {
        if (y <= pts[i].y) { const a = pts[i - 1], b = pts[i]; return a.h + (b.h - a.h) * ((y - a.y) / ((b.y - a.y) || 1)); }
      }
      return START + SPAN;
    };
    const chapters = () => $$('main section[id]').filter((sec) => sec.querySelector('h2') && sec.offsetHeight > 0).map((sec) => ({ id: sec.id, title: sec.querySelector('h2').textContent.trim().replace(/\s+/g, ' '), top: sec.getBoundingClientRect().top + scrollY }));
    const build = () => {
      pts = anchors();
      list.innerHTML = '';
      chapters().forEach((c) => {
        const li = document.createElement('li'), a = document.createElement('a'), t = document.createElement('time');
        a.href = `#${c.id}`; t.textContent = fmt(hourAt(Math.max(0, c.top - innerHeight * 0.35)));
        a.append(t, document.createTextNode(c.title)); li.append(a); list.append(li);
      });
    };
    let ticking = false;
    const update = () => {
      ticking = false;
      const h = hourAt(scrollY);
      label.textContent = fmt(h);
      hH.setAttribute('transform', `rotate(${(h % 12) * 30})`);
      hM.setAttribute('transform', `rotate(${(h % 1) * 360})`);
      dayClock.dataset.part = partOf(h);
      const past = hero ? scrollY > hero.offsetHeight * 0.6 : scrollY > 400;
      if (past === dayClock.hidden) dayClock.hidden = !past;
      if (!past && !menu.hidden) toggle(false);
    };
    const toggle = (open) => {
      if (open) build();
      menu.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      if (open) $('a', list)?.focus();
    };
    btn.addEventListener('click', () => toggle(menu.hidden));
    list.addEventListener('click', (e) => { if (e.target.closest('a')) toggle(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !menu.hidden) { toggle(false); btn.focus(); } });
    document.addEventListener('click', (e) => { if (!menu.hidden && !dayClock.contains(e.target)) toggle(false); });
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    addEventListener('resize', () => { pts = anchors(); update(); });
    addEventListener('load', () => { pts = anchors(); update(); });
    update();
  }

  /* ---------- Chiki Radio: Chiki Toonz on Spotify, docked; the iframe is created on the first tap ---------- */
  const radio = $('[data-ck-radio-dock]');
  if (radio) {
    const frame = $('[data-radio-frame]', radio), minBtn = $('[data-radio-min]', radio);
    const setMin = (min) => {
      radio.classList.toggle('is-min', min);
      minBtn.setAttribute('aria-expanded', String(!min));
      minBtn.setAttribute('aria-label', min ? minBtn.dataset.labelMax : minBtn.dataset.labelMin);
    };
    const openRadio = () => {
      if (!frame.firstChild) {
        const f = document.createElement('iframe');
        f.src = radio.dataset.src;
        f.title = radio.getAttribute('aria-label');
        f.allow = 'autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture';
        f.loading = 'eager';
        frame.append(f);
      }
      radio.hidden = false;
      document.documentElement.classList.add('ck-radio-on');
      window.dispatchEvent(new Event('ck:radio-open'));
      setMin(false);
      minBtn.focus();
    };
    document.addEventListener('click', (e) => { if (e.target.closest('[data-ck-radio]')) { e.preventDefault(); openRadio(); } });
    minBtn.addEventListener('click', () => setMin(!radio.classList.contains('is-min')));
    $('[data-radio-close]', radio).addEventListener('click', () => {
      frame.innerHTML = '';
      radio.hidden = true;
      document.documentElement.classList.remove('ck-radio-on');
      $('[data-ck-radio]')?.focus();
    });
  }

  /* ---------- Songs for your day: mark the moment that matches the visitor's hour ---------- */
  $$('[data-ck-moments]').forEach((sec) => {
    const h = parseFloat(document.documentElement.dataset.hour);
    if (isNaN(h)) return;
    const tile = $$('.ck-mo', sec).find((li) => {
      const from = parseFloat(li.dataset.from), to = parseFloat(li.dataset.to);
      if (isNaN(from) || isNaN(to)) return false;
      return from <= to ? h >= from && h < to : h >= from || h < to; // e.g. bedtime 20.5 → 5 wraps past midnight
    });
    if (!tile) return;
    tile.classList.add('is-now');
    $('[data-mo-now]', tile).hidden = false;
    const row = $('[data-mo-row]', sec);
    if (row && row.scrollWidth > row.clientWidth) row.scrollLeft = Math.max(0, tile.getBoundingClientRect().left - row.getBoundingClientRect().left + row.scrollLeft - 16);
  });

  /* ---------- 21:30 Buenas noches: pull the moon down and the sun rises, back to the top of the day ---------- */
  $$('[data-ck-night]').forEach((sec) => {
    const moon = $('[data-night-moon]', sec), dawn = $('[data-night-dawn]', sec);
    if (!moon) return;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const RANGE = 180;
    let startY = null, dy = 0, dragged = false;
    const set = (v) => { dy = Math.max(0, Math.min(RANGE, v)); moon.style.translate = `0 ${dy}px`; dawn.style.opacity = String(dy / RANGE * 0.85); };
    const sunrise = () => {
      track('moon_sunrise');
      sec.classList.add('is-rising');
      moon.style.transition = 'translate .6s ease'; set(RANGE); dawn.style.opacity = '1';
      setTimeout(() => {
        const hero = $('#ck-hero');
        (hero || document.body).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        setTimeout(() => { sec.classList.remove('is-rising'); moon.style.transition = ''; set(0); }, reduce ? 50 : 1400);
      }, reduce ? 0 : 700);
    };
    moon.addEventListener('pointerdown', (e) => { startY = e.clientY; dragged = false; moon.setPointerCapture(e.pointerId); moon.style.transition = ''; });
    moon.addEventListener('pointermove', (e) => { if (startY === null) return; const v = e.clientY - startY; if (Math.abs(v) > 6) dragged = true; set(v); });
    const end = () => {
      if (startY === null) return;
      startY = null;
      if (!dragged || dy > RANGE * 0.5) return; // a tap or a long pull → the click handler rises the sun
      moon.style.transition = 'translate .4s cubic-bezier(.34,1.56,.64,1)'; dawn.style.transition = 'opacity .4s'; set(0);
    };
    moon.addEventListener('pointerup', end);
    moon.addEventListener('pointercancel', end);
    moon.addEventListener('click', (e) => {
      e.preventDefault();
      if (dragged && dy <= RANGE * 0.5) { dragged = false; return; } // short drag that snapped back
      dragged = false; sunrise();
    });
  });

  /* ---------- Shop windows: filter by moment of the day; option popovers close on outside tap ---------- */
  $$('[data-ck-windows]').forEach((sec) => {
    const chips = $$('.ck-chip', sec), cells = $$('.ck-win-cell', sec), status = $('[data-win-status]', sec);
    chips.forEach((chip) => chip.addEventListener('click', () => {
      const f = chip.dataset.filter;
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      let n = 0;
      cells.forEach((cell) => { const show = !f || $('.ck-win', cell)?.dataset.moment === f; cell.hidden = !show; if (show) n++; });
      if (status) status.textContent = `${n} · ${chip.textContent.trim()}`;
    }));
    // Hide chips for moments that have no product yet
    chips.forEach((chip) => { const f = chip.dataset.filter; if (f && !cells.some((c) => $('.ck-win', c)?.dataset.moment === f)) chip.hidden = true; });
  });
  document.addEventListener('click', (e) => {
    $$('details.ck-win-pick[open]').forEach((d) => { if (!d.contains(e.target)) d.open = false; });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const d = $('details.ck-win-pick[open]');
    if (d) { d.open = false; $('summary', d)?.focus(); }
  });

  /* ---------- Sticky add to cart (product page, phones): presses the real form button ---------- */
  const stickyAtc = $('[data-sticky-atc]');
  const mainAdd = $('.product-form__submit');
  if (stickyAtc && mainAdd && 'IntersectionObserver' in window) {
    const priceEl = $('[data-sticky-price]', stickyAtc);
    const syncPrice = () => {
      const p = $('.product .price .price-item--sale, .product .price .price-item--regular, .price .price-item--regular');
      if (p && priceEl && p.textContent.trim()) priceEl.textContent = p.textContent.trim();
    };
    const small = matchMedia('(max-width: 749px)');
    let away = false;
    const show = () => { const on = away && small.matches && !mainAdd.disabled; if (on) syncPrice(); stickyAtc.hidden = !on; document.documentElement.classList.toggle('ck-has-sticky', on); };
    new IntersectionObserver(([en]) => { away = !en.isIntersecting; show(); }, { threshold: 0.2 }).observe(mainAdd);
    small.addEventListener?.('change', show);
    document.addEventListener('change', () => setTimeout(show, 350));
    $('[data-sticky-add]', stickyAtc).addEventListener('click', () => { if (!mainAdd.disabled) mainAdd.click(); });
  }

  /* ---------- Kits: several products into the bag in one tap; the total follows the chosen options ---------- */
  $$('[data-ck-kits]').forEach((sec) => {
    // Format cents like the store does, by copying the separators from a server-rendered sample ("S/. 1,234.56")
    const sample = sec.dataset.moneySample || '';
    const m = sample.match(/\d[\d.,\s]*\d|\d/);
    const fmt = (cents) => {
      if (!m) return (cents / 100).toFixed(2);
      const num = m[0];
      const dec = /[.,]\d{2}$/.test(num) ? num.slice(-3, -2) : '';
      const thou = (num.slice(0, dec ? -3 : undefined).match(/[.,\s]/) || [''])[0];
      const units = Math.floor(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, thou || (dec === ',' ? '.' : ','));
      const out = dec ? `${units}${dec}${String(Math.round(cents % 100)).padStart(2, '0')}` : String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return sample.replace(num, out);
    };
    $$('[data-kit]', sec).forEach((kit) => {
      const items = $$('[data-kit-item]', kit), total = $('[data-kit-total]', kit), add = $('[data-kit-add]', kit);
      const price = (el) => +(el.tagName === 'SELECT' ? el.selectedOptions[0]?.dataset.price : el.dataset.price) || 0;
      const sum = () => { if (total) total.textContent = fmt(items.reduce((t, el) => t + price(el), 0)); };
      items.forEach((el) => el.tagName === 'SELECT' && el.addEventListener('change', sum));
      add?.addEventListener('click', async () => {
        add.disabled = true;
        const drawer = document.querySelector('cart-drawer');
        // Same request shape as the single-product button (form fields), with one items[] entry per product
        const body = new FormData();
        items.forEach((el, i) => { body.append(`items[${i}][id]`, el.value); body.append(`items[${i}][quantity]`, 1); });
        body.append('sections', drawer ? drawer.getSectionsToRender().map((x) => x.id) : ['cart-icon-bubble']);
        body.append('sections_url', window.Shopify?.routes?.root || '/'); // the root always renders sections; /collections/all does not
        try {
          const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body,
          });
          const json = await res.json();
          if (json.status) throw new Error(json.description || json.message);
          // Multi-item adds come back without the rendered sections, so ask for them (Section Rendering API)
          if (!json.sections) json.sections = await cartSections(drawer);
          if (drawer && json.sections) {
            drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
            drawer.renderContents(json);
          } else if (json.sections?.['cart-icon-bubble']) {
            const html = new DOMParser().parseFromString(json.sections['cart-icon-bubble'], 'text/html');
            const inner = html.querySelector('.shopify-section');
            if (inner) $('#cart-icon-bubble').innerHTML = inner.innerHTML;
          }
          bumpBubble();
          if (!drawer || !json.sections) say(S.added);
          track('kit_add', { kit: $('h3', kit)?.textContent.trim() || '', items: items.length });
        } catch (err) {
          say(err?.message || S.addError);
        } finally {
          add.disabled = false;
        }
      });
    });
  });

  /* ---------- Chiki Piano: toy piano in Web Audio; free play, guided "learn" and "listen" ---------- */
  $$('[data-ck-piano]').forEach((root) => {
    const keys = $$('.ck-pk', root);
    const byMidi = new Map(keys.map((k) => [+k.dataset.midi, k]));
    const status = $('[data-status]', root), songsBox = $('[data-songs]', root), scroll = $('[data-scroll]', root);
    const bar = $('.ck-piano-progress', root), fill = $('[data-progress]', root);
    const modeBtns = $$('[data-mode]', root);
    const T = { bravo: root.dataset.tBravo || '¡Bravo!', next: root.dataset.tNext || '', playing: root.dataset.tPlaying || '' };
    const freeHint = status.textContent;
    let ctx = null, master = null, songs = [], song = null, mode = 'free', step = 0, timers = [];

    // A toy-piano voice: a triangle wave with a bright, quickly fading "tine" an octave and a fifth up
    const audio = () => {
      if (ctx) return ctx;
      try {
        ctx = new (window.AudioContext || window.webkitAudioContext)();
        master = ctx.createGain(); master.gain.value = 0.55;
        const comp = ctx.createDynamicsCompressor();
        master.connect(comp).connect(ctx.destination);
      } catch (e) { ctx = null; }
      return ctx;
    };
    const tone = (midi, len = 0.9) => {
      const c = audio(); if (!c) return;
      if (c.state === 'suspended') c.resume();
      const f = 440 * 2 ** ((midi - 69) / 12), t = c.currentTime;
      const body = c.createOscillator(), tine = c.createOscillator(), g = c.createGain(), gt = c.createGain();
      body.type = 'triangle'; body.frequency.value = f;
      tine.type = 'sine'; tine.frequency.value = f * 3;
      g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.5, t + 0.006); g.gain.exponentialRampToValueAtTime(0.0001, t + len + 0.5);
      gt.gain.setValueAtTime(0.0001, t); gt.gain.exponentialRampToValueAtTime(0.18, t + 0.004); gt.gain.exponentialRampToValueAtTime(0.0001, t + 0.25);
      body.connect(g).connect(master); tine.connect(gt).connect(master);
      body.start(t); tine.start(t); body.stop(t + len + 0.6); tine.stop(t + 0.3);
    };
    const flash = (midi) => {
      const k = byMidi.get(midi); if (!k) return;
      k.classList.add('is-down'); setTimeout(() => k.classList.remove('is-down'), 170);
    };
    // Keep a key inside the scrollable keyboard (phones), measured from the viewport so nesting doesn't matter
    const reveal = (midi) => {
      const k = byMidi.get(midi); if (!k || scroll.scrollWidth <= scroll.clientWidth) return;
      const kr = k.getBoundingClientRect(), sr = scroll.getBoundingClientRect();
      if (kr.left < sr.left + 24 || kr.right > sr.right - 24) {
        const left = scroll.scrollLeft + (kr.left - sr.left) - sr.width / 2 + kr.width / 2;
        scroll.scrollTo({ left: Math.max(0, left), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    };
    // Narrow screens show only the keys needed (Do4–Do5 for free play, the song's range otherwise), sized to fill the frame
    const narrow = matchMedia('(max-width: 760px)');
    const isWhite = (m) => ![1, 3, 6, 8, 10].includes(m % 12);
    const keysBox = $('.ck-piano-keys', root);
    const fit = () => {
      let lo = 60, hi = 84;
      if (narrow.matches) {
        if (song && mode !== 'free') {
          const ps = song.notes.map((n) => n[2]); lo = Math.min(...ps); hi = Math.max(...ps);
          while (!isWhite(lo)) lo -= 1; while (!isWhite(hi)) hi += 1;
          const whites = () => { let c = 0; for (let m = lo; m <= hi; m++) if (isWhite(m)) c++; return c; };
          while (whites() < 8) { if (hi < 84) { hi += 1; while (!isWhite(hi)) hi += 1; } if (whites() < 8 && lo > 60) { lo -= 1; while (!isWhite(lo)) lo -= 1; } if (lo <= 60 && hi >= 84) break; }
        } else { lo = 60; hi = 72; }
      }
      let n = 0;
      keys.forEach((k) => { const m = +k.dataset.midi; const on = m >= lo && m <= hi; k.hidden = !on; if (on && isWhite(m)) n++; });
      keysBox.style.setProperty('--n', n);
    };
    narrow.addEventListener?.('change', fit);
    const clearTarget = () => keys.forEach((k) => k.classList.remove('is-target'));
    const stop = () => { timers.forEach(clearTimeout); timers = []; };
    const say = (text) => { status.textContent = text; };
    const setProgress = (p) => { bar.hidden = p == null; if (p != null) fill.style.width = `${Math.round(p * 100)}%`; };

    const target = () => {
      clearTarget();
      const n = song?.notes[step]; if (!n) return;
      const k = byMidi.get(n[2]); if (k) { k.classList.add('is-target'); reveal(n[2]); }
      setProgress(step / song.notes.length);
    };
    const finish = () => {
      track('piano_song_done', { song: song.key });
      clearTarget(); setProgress(1);
      say(T.bravo.replace('{{ title }}', song.title).replace('{title}', song.title));
      root.classList.add('is-bravo'); setTimeout(() => root.classList.remove('is-bravo'), 1600);
      // a little fanfare
      [0, 4, 7, 12].forEach((iv, i) => timers.push(setTimeout(() => tone(72 + iv, 0.5), i * 120)));
      step = 0;
      timers.push(setTimeout(() => { if (mode === 'learn') { say(T.next); target(); } }, 2600));
    };
    const listen = () => {
      stop(); clearTarget();
      if (!song) return;
      const beat = 60 / song.bpm * 1000;
      say(T.playing.replace('{{ title }}', song.title).replace('{title}', song.title));
      song.notes.forEach(([at, len, midi], i) => {
        timers.push(setTimeout(() => { tone(midi, Math.min(1.2, len * beat / 1000 + 0.15)); flash(midi); reveal(midi); setProgress((i + 1) / song.notes.length); }, at * beat));
      });
      const end = song.notes.at(-1); timers.push(setTimeout(() => { setProgress(null); say(song.title); }, (end[0] + end[1]) * beat + 300));
    };

    const press = (midi) => {
      once(`piano-${mode}`, 'piano_play', { mode, place: place(root) });
      tone(midi); flash(midi);
      if (mode === 'learn' && song) {
        if (song.notes[step]?.[2] === midi) { step += 1; if (step >= song.notes.length) finish(); else target(); }
      }
    };
    keys.forEach((k) => k.addEventListener('pointerdown', (e) => { e.preventDefault(); press(+k.dataset.midi); }));
    keys.forEach((k) => k.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); press(+k.dataset.midi); } }));

    // Computer keyboard: A W S E D F T G Y H U J K … = Do Do♯ Re Re♯ Mi Fa Fa♯ Sol …, while the piano is on screen
    const MAP = 'awsedftgyhujkolp;\''.split('');
    let onScreen = false;
    new IntersectionObserver(([en]) => { onScreen = en.isIntersecting; }, { threshold: 0.3 }).observe(root);
    document.addEventListener('keydown', (e) => {
      if (!onScreen || e.repeat || e.metaKey || e.ctrlKey || e.altKey) return;
      if (e.target.closest('input, textarea, select, [contenteditable]')) return;
      const i = MAP.indexOf(e.key.toLowerCase());
      if (i < 0) return;
      e.preventDefault(); press(60 + i);
    });

    const setMode = (m) => {
      stop(); clearTarget(); setProgress(null); mode = m;
      modeBtns.forEach((b) => b.setAttribute('aria-checked', String(b.dataset.mode === m)));
      songsBox.hidden = m === 'free';
      if (m === 'free') { fit(); say(freeHint); return; }
      if (!song) pick(songs[0]);
      else if (m === 'learn') { step = 0; say(T.next); target(); }
      else listen();
    };
    const pick = (sg) => {
      song = sg; step = 0; fit();
      $$('button', songsBox).forEach((b) => b.setAttribute('aria-checked', String(b.dataset.key === sg.key)));
      if (mode === 'learn') { stop(); say(T.next); target(); }
      else if (mode === 'listen') listen();
    };
    modeBtns.forEach((b) => b.addEventListener('click', () => { audio(); setMode(b.dataset.mode); if (b.dataset.mode !== 'free') once(`piano-mode-${b.dataset.mode}`, 'piano_mode', { mode: b.dataset.mode }); }));

    fetch(root.dataset.src).then((r) => r.json()).then((d) => {
      songs = d.songs || [];
      songs.forEach((sg) => {
        const b = document.createElement('button');
        b.type = 'button'; b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', 'false'); b.dataset.key = sg.key;
        b.style.setProperty('--c', sg.color); b.textContent = sg.title; b.lang = 'es';
        b.addEventListener('click', () => { audio(); pick(sg); track('piano_song', { song: sg.key, mode }); });
        songsBox.append(b);
      });
    }).catch(() => { modeBtns.filter((b) => b.dataset.mode !== 'free').forEach((b) => { b.hidden = true; }); });
    fit();
  });

  /* ---------- Next show: homepage promos read the tour page's Event data (upcoming shows only) ---------- */
  const nsBoxes = $$('[data-ck-nextshow]');
  if (nsBoxes.length) {
    const url = nsBoxes[0].dataset.ckNextshow;
    const KEY = `ck-ns2:${url}`;
    const load = async () => {
      try {
        const c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        if (c && Date.now() - c.at < 30 * 60 * 1000) return c.events;
      } catch (e) { /* no cache */ }
      const html = await (await fetch(url, { credentials: 'same-origin' })).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const events = $$('script[type="application/ld+json"]', doc).map((sc) => { try { return JSON.parse(sc.textContent); } catch (e) { return null; } })
        .filter((ev) => ev && ev['@type'] === 'Event' && ev.startDate);
      // Shows from the last two weeks (plain JSON on the tour page), for the thank-you
      $$('script[data-ck-recent-shows]', doc).forEach((sc) => { try { events.push(...JSON.parse(sc.textContent).filter((ev) => ev && ev.startDate)); } catch (e) { /* ignore */ } });
      try { sessionStorage.setItem(KEY, JSON.stringify({ at: Date.now(), events })); } catch (e) { /* ok */ }
      return events;
    };
    // Which show this visitor cares about: one in their country (Portuguese → Brazil) first, then the soonest anywhere.
    // The day after a show, the promo turns into a thank-you for two weeks (unless the visitor has an upcoming show nearby).
    const ALIASES = { AR: 'argentina', BR: 'brasil brazil', ES: 'espana spain', MX: 'mexico', US: 'estados unidos united states usa', PE: 'peru', CO: 'colombia', CL: 'chile', UY: 'uruguay', PT: 'portugal' };
    const norm = (t) => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
    const lang = document.documentElement.lang || 'es';
    const mine = new Set([nsBoxes.find((b) => b.dataset.nsCountry)?.dataset.nsCountry, lang.startsWith('pt') ? 'BR' : ''].filter(Boolean));
    const local = (ev) => { const c = norm(ev.location?.address?.addressCountry); return [...mine].some((cc) => (ALIASES[cc] || '').split(' ').concat(norm(cc)).some((a) => a && c.includes(a))); };
    const pickShow = (events) => {
      const today = new Date(); today.setHours(0, 0, 0, 0);
      const DAY = 864e5;
      const day = (ev) => new Date(`${ev.startDate.slice(0, 10)}T23:59:59`);
      const soon = events.filter((ev) => day(ev) >= today).sort((a, b) => a.startDate.localeCompare(b.startDate));
      const past = events.filter((ev) => day(ev) < today && today - day(ev) < 14 * DAY).sort((a, b) => b.startDate.localeCompare(a.startDate));
      const pick = soon.find(local) ? [soon.find(local), false] : past.find(local) ? [past.find(local), true] : soon[0] ? [soon[0], false] : past[0] ? [past[0], true] : [null];
      if (pick[0]) pick.push(Math.round((new Date(`${pick[0].startDate.slice(0, 10)}T00:00:00`) - today) / DAY));
      return pick;
    };
    const fillShow = (boxes, events) => {
      const [next, thanks, days] = pickShow(events);
      if (!next) { boxes.forEach((b) => b.remove()); return; }
      const d = new Date(`${next.startDate.slice(0, 10)}T12:00:00`);
      let date = new Intl.DateTimeFormat(lang, { weekday: 'long', day: 'numeric', month: 'long' }).format(d);
      date = date.charAt(0).toUpperCase() + date.slice(1);
      const loc = next.location || {};
      const city = loc.address?.addressLocality || '';
      const where = [city, loc.address?.addressCountry].filter(Boolean).join(', ');
      // The show's own clock time, as written on the tour page (no time-zone conversion)
      const hm = (next.startDate.match(/T(\d{2}):(\d{2})/) || []).slice(1);
      let time = '';
      if (hm.length && !(hm[0] === '00' && hm[1] === '00')) {
        const h = +hm[0];
        time = lang.startsWith('en') ? `${(h % 12) || 12}:${hm[1]} ${h < 12 ? 'AM' : 'PM'}` : `${hm[0]}:${hm[1]} h`;
      }
      const meta = [time, loc.name].filter(Boolean).join(' · ');
      const sub = next.alternateName || '';
      const ticket = next.offers?.url;
      const fill = (tpl) => String(tpl || '').replace('{x}', city).replace('{city}', city).replace('{n}', days);
      const set = (box, sel, text) => $$(sel, box).forEach((el) => { el.textContent = text; el.hidden = !text; });
      boxes.forEach((box) => {
        box.classList.toggle('is-thanks', thanks);
        const link = box.matches('[data-ns-link]') ? box : $('[data-ns-link]', box);
        if (thanks) {
          set(box, '[data-ns-kicker]', fill(S.nsThanks || '{city}'));
          set(box, '[data-ns-sub]', '');
          set(box, '[data-ns-date]', S.nsThanksTitle || '');
          set(box, '[data-ns-where]', '');
          set(box, '[data-ns-meta]', '');
          $$('[data-ns-cal]', box).forEach((el) => { el.hidden = true; });
          // With photos on the tour page the thank-you leads there; otherwise to the songs
          const photos = next.gallery && box.dataset.ckNextshow;
          $$('[data-ns-cta]', box).forEach((el) => { el.textContent = (photos ? S.nsPhotosCta : S.nsThanksCta) || el.textContent; });
          if (link && (photos || box.dataset.nsAfter)) { link.href = photos ? `${box.dataset.ckNextshow}#fotos` : box.dataset.nsAfter; link.removeAttribute('target'); }
        } else {
          set(box, '[data-ns-sub]', sub);
          set(box, '[data-ns-date]', date);
          set(box, '[data-ns-where]', where);
          set(box, '[data-ns-meta]', meta);
          // Calendar badge: "Faltan 8 días", "Mañana", "¡Hoy!"; hidden when the show is far away
          $$('[data-ns-cal]', box).forEach((cal) => {
            const word = days === 0 ? S.nsCalToday : days === 1 ? S.nsCalTomorrow : '';
            cal.classList.toggle('is-word', !!word);
            $('[data-ns-cal-top]', cal).textContent = word ? '' : (S.nsCalTop || '');
            $('[data-ns-days]', cal).textContent = word || String(days);
            $('[data-ns-cal-unit]', cal).textContent = word ? '' : (S.nsCalDays || '');
            cal.hidden = !(days >= 0 && days <= 99);
          });
          if (link && ticket) link.href = ticket;
        }
        box.hidden = false;
      });
    };
    // The radio's line only asks for the tour page once the radio is opened
    const eager = nsBoxes.filter((b) => !b.hasAttribute('data-ns-lazy'));
    const lazy = nsBoxes.filter((b) => b.hasAttribute('data-ns-lazy'));
    if (eager.length) load().then((ev) => fillShow(eager, ev)).catch(() => eager.forEach((b) => b.remove()));
    if (lazy.length) window.addEventListener('ck:radio-open', () => load().then((ev) => fillShow(lazy, ev)).catch(() => lazy.forEach((b) => b.remove())), { once: true });
  }

  /* ---------- Product specs: the supplier's description, sorted into intro, details, size guide and care ----------
     Print-on-demand descriptions mix paragraphs, "Label: value" bullets, size tables (cm and inches) and care tables.
     The original HTML stays in the page source; without JS it shows as it is. */
  $$('[data-ck-specs]').forEach((box) => {
    const T = S.specs || {};
    const txt = (el) => el.textContent.replace(/\s+/g, ' ').trim();
    const heading = (el) => /^(size guide|care instructions|gu[ií]a de tallas|guia de tamanhos|instrucciones de cuidado|cuidados?)\b/i.test(txt(el)) && el.querySelector('strong, b') && txt(el).length < 40;
    let nodes = [...box.children];
    while (nodes.length === 1 && nodes[0].tagName === 'DIV') nodes = [...nodes[0].children];
    const intro = [], specs = [], notes = [], sizeTables = [], careRows = [];
    let mode = '';
    const addSpec = (line) => {
      line = line.replace(/^[-•·]\s*/, '').replace(/\.$/, '').trim();
      if (!line) return;
      const m = line.match(/^([^:]{2,40}):\s*(.+)$/);
      specs.push(m ? { k: m[1].trim(), v: m[2].trim() } : { v: line });
    };
    nodes.forEach((el) => {
      const t = txt(el);
      if (el.tagName === 'BR' || (!t && el.tagName !== 'TABLE')) return;
      if (/made on demand|no minimums/i.test(t)) return; // supplier production note, not for customers
      if (heading(el)) { mode = /size|talla|tamanho/i.test(t) ? 'size' : 'care'; return; }
      if (el.tagName === 'TABLE') {
        if (mode === 'care') [...el.rows].forEach((r) => r.cells.length > 1 && careRows.push({ k: txt(r.cells[0]), v: txt(r.cells[1]) }));
        else if (mode === 'size') sizeTables.push(el);
        else [...el.rows].forEach((r) => r.cells.length > 1 && specs.push({ k: txt(r.cells[0]), v: txt(r.cells[1]) }));
        return;
      }
      if (el.tagName === 'UL' || el.tagName === 'OL') { [...el.children].forEach((li) => addSpec(txt(li))); return; }
      if (/^(please note|nota|observa[cç][aã]o)\b/i.test(t)) { notes.push(t.replace(/^(please note|nota|observa[cç][aã]o):?\s*/i, '')); return; }
      const lead = el.querySelector(':scope > strong:first-child, :scope > b:first-child');
      if (lead && /:\s*$/.test(lead.textContent)) { specs.push({ k: lead.textContent.replace(/:\s*$/, '').trim(), v: t.slice(lead.textContent.trim().length).trim() }); return; }
      const lines = el.innerHTML.split(/<br\s*\/?>/i).map((h) => { const d = document.createElement('div'); d.innerHTML = h; return txt(d); }).filter(Boolean);
      if (lines.length > 1 && lines.every((l) => /^[-•·]/.test(l))) { lines.forEach(addSpec); return; }
      if (!specs.length && !sizeTables.length) intro.push(t); else notes.push(t);
    });
    if (!specs.length && !sizeTables.length && !careRows.length) return; // nothing to sort: leave the description as it is

    // Size guide: one table, sizes in natural order, cm / inches switch
    const ORDER = ['NB', '0-3M', '3-6M', '6M', '6-12M', '12M', '18M', '24M', '2T', '3T', '4T', '5T', '6', '8', '10', '12', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', 'OS'];
    const rank = (sz) => { const i = ORDER.indexOf(sz.toUpperCase()); return i < 0 ? 999 : i; };
    const rowName = (label) => {
      const l = label.replace(/\((cm|inches|in|pulgadas|polegadas)\)/i, '').trim();
      const key = /half chest/i.test(l) ? 'r_chest' : /sleeve/i.test(l) ? 'r_sleeve' : /length/i.test(l) ? 'r_length' : /width/i.test(l) ? 'r_width' : '';
      const letter = (l.match(/^([A-Z])\)\s*/) || [])[1];
      return (letter ? `${letter}) ` : '') + (key && T[key] ? T[key] : l.replace(/^[A-Z]\)\s*/, ''));
    };
    const units = {};
    sizeTables.forEach((tb) => {
      const rows = [...tb.rows].map((r) => [...r.cells].map(txt));
      if (rows.length < 2) return;
      const head = rows[0].slice(1);
      const order = head.map((h, i) => i).sort((a, b) => rank(head[a]) - rank(head[b]));
      rows.slice(1).forEach((r) => {
        const u = /inch|pulgada|polegada|\(in\)/i.test(r[0]) ? 'in' : 'cm';
        (units[u] = units[u] || { head: order.map((i) => head[i]), rows: [] }).rows.push([rowName(r[0]), ...order.map((i) => r[i + 1])]);
      });
    });

    const esc = (v) => String(v).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const list = (items) => `<dl class="ck-spec-list">${items.map((it) => it.k ? `<div><dt>${esc(it.k)}</dt><dd>${esc(it.v)}</dd></div>` : `<div class="is-plain"><dd>${esc(it.v)}</dd></div>`).join('')}</dl>`;
    const careKey = (k) => ({ general: 'c_general', wash: 'c_wash', dry: 'c_dry', store: 'c_store', iron: 'c_iron', 'tumble dry': 'c_tumble', bleach: 'c_bleach', 'dry clean': 'c_dryclean' })[k.toLowerCase().trim()];
    const table = (u) => `<div class="ck-size-scroll"><table class="ck-size-table" data-unit="${u}"${u === 'cm' || !units.cm ? '' : ' hidden'}><thead><tr><th scope="col"><span class="ck-sr-only">${esc(T.size || '')}</span></th>${units[u].head.map((h) => `<th scope="col">${esc(h)}</th>`).join('')}</tr></thead><tbody>${units[u].rows.map((r) => `<tr><th scope="row">${esc(r[0])}</th>${r.slice(1).map((c) => `<td>${esc(c)}</td>`).join('')}</tr>`).join('')}</tbody></table></div>`;
    const unitKeys = Object.keys(units).sort((a) => (a === 'cm' ? -1 : 1));
    let html = '';
    if (intro.length) html += `<div class="ck-spec-intro">${intro.map((p) => `<p>${esc(p)}</p>`).join('')}</div>`;
    if (specs.length || notes.length) html += `<details class="ck-spec" open><summary>${esc(T.details || '')}</summary>${specs.length ? list(specs) : ''}${notes.map((n) => `<p class="ck-spec-note">${esc(n)}</p>`).join('')}</details>`;
    if (unitKeys.length) {
      const sw = unitKeys.length > 1 ? `<div class="ck-unit-switch" role="group" aria-label="${esc(T.units || '')}">${unitKeys.map((u, i) => `<button type="button" data-unit="${u}" aria-pressed="${i === 0}">${esc(T[u] || u)}</button>`).join('')}</div>` : '';
      html += `<details class="ck-spec"><summary>${esc(T.size || '')}</summary>${sw}${unitKeys.map(table).join('')}<p class="ck-spec-note">${esc(T.size_note || '')}</p></details>`;
    }
    if (careRows.length) html += `<details class="ck-spec"><summary>${esc(T.care || '')}</summary>${list(careRows.map((r) => ({ k: T[careKey(r.k)] || r.k, v: r.v })))}</details>`;
    box.innerHTML = html;
    box.classList.add('ck-specs');
    $$('.ck-unit-switch button', box).forEach((b) => b.addEventListener('click', () => {
      $$('.ck-unit-switch button', box).forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      $$('.ck-size-table', box).forEach((tb) => { tb.hidden = tb.dataset.unit !== b.dataset.unit; });
    }));
  });

  /* ---------- Show photos: whole photos in a masonry; a viewer with previous / next, arrows and Escape ---------- */
  $$('[data-ck-photos]').forEach((sec) => {
    const btns = $$('[data-photo]', sec), dlg = $('[data-viewer]', sec);
    if (!dlg || !btns.length || typeof dlg.showModal !== 'function') return;
    const img = $('[data-viewer-img]', dlg), count = $('[data-viewer-count]', dlg);
    let i = 0, opener = null;
    const show = (n) => {
      i = (n + btns.length) % btns.length;
      const thumb = $('img', btns[i]);
      img.src = btns[i].dataset.photo; img.alt = thumb.alt;
      img.width = thumb.width; img.height = thumb.height;
      count.textContent = `${i + 1} / ${btns.length}`;
    };
    btns.forEach((b, n) => b.addEventListener('click', () => { opener = b; show(n); dlg.showModal(); document.documentElement.classList.add('ck-noscroll'); track('photo_open', { n: n + 1 }); }));
    $('[data-viewer-prev]', dlg).addEventListener('click', () => show(i - 1));
    $('[data-viewer-next]', dlg).addEventListener('click', () => show(i + 1));
    $('[data-viewer-close]', dlg).addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); }); // tap outside the photo
    dlg.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') show(i - 1); else if (e.key === 'ArrowRight') show(i + 1); });
    let x0 = null; // swipe on phones
    dlg.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    dlg.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) show(i + (dx < 0 ? 1 : -1)); x0 = null; });
    dlg.addEventListener('close', () => { document.documentElement.classList.remove('ck-noscroll'); opener?.focus(); });
  });

  /* ---------- Halloween pumpkin: pick eyes and mouth; "¡Buuu!" glows, wobbles and says boo (Web Audio, no files) ---------- */
  $$('[data-ck-pumpkin]').forEach((toy) => {
    const svg = $('svg', toy);
    let ctx = null;
    const boo = () => {
      try {
        ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
        const t = ctx.currentTime, o = ctx.createOscillator(), g = ctx.createGain(), lfo = ctx.createOscillator(), lg = ctx.createGain();
        o.type = 'triangle'; o.frequency.setValueAtTime(520, t); o.frequency.exponentialRampToValueAtTime(180, t + 0.9);
        lfo.frequency.value = 7; lg.gain.value = 18; lfo.connect(lg); lg.connect(o.frequency); // a wobbly, friendly "booo"
        g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.25, t + 0.06); g.gain.exponentialRampToValueAtTime(0.0001, t + 1);
        o.connect(g); g.connect(ctx.destination); o.start(t); lfo.start(t); o.stop(t + 1.05); lfo.stop(t + 1.05);
      } catch (e) { /* no sound, still fun */ }
    };
    $$('[data-pk]', toy).forEach((b) => b.addEventListener('click', () => {
      const what = b.dataset.pk;
      if (what === 'boo') {
        toy.classList.remove('is-boo'); reflow(toy); toy.classList.add('is-boo'); boo();
        setTimeout(() => toy.classList.remove('is-boo'), 1300);
        once('pumpkin', 'pumpkin_boo');
        return;
      }
      svg.dataset[what] = String((+svg.dataset[what] + 1) % 4);
    }));
  });

  /* ---------- Measurement: taps that need no module of their own ---------- */
  const TICKETS = /ticket|plateanet|joinnus|teleticket|passline|eventbrite|tuboleta|ticketek|entradas|boleter/i;
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('[data-ck-radio]')) return track('radio_open', { place: place(t) });
    const v = t.closest('[data-ck-video]');
    if (v) return track('video_play', { video: v.dataset.ckVideo, title: v.dataset.title || '', place: place(v) });
    if (t.closest('[data-ck-ics]')) return track('calendar_add', { show: t.closest('[data-ck-ics]').dataset.title || '' });
    const ns = t.closest('[data-ck-nextshow]');
    if (ns) return track('nextshow_click', { place: place(ns), mode: ns.classList.contains('is-thanks') ? 'thanks' : 'tickets' });
    const a = t.closest('a[href^="http"]');
    if (a && a.host !== location.host) {
      if (TICKETS.test(a.href) || a.closest('.ck-tour')) track('ticket_click', { host: a.host, place: place(a) });
      else track('outbound_click', { host: a.host, place: place(a) });
    }
  }, { capture: true });
  // First touch in a game (memory, siluetas) or the sing-along player
  document.addEventListener('pointerdown', (e) => {
    const g = e.target.closest('#ck-play, #ck-siluetas, [data-ck-cya]');
    if (g) once(`game-${g.id || 'cya'}`, g.matches('[data-ck-cya]') ? 'singalong_play' : 'game_start', { game: g.id || 'cya' });
  }, { capture: true, passive: true });
  if (document.querySelector('.ck-song-hero')) track('lyrics_view', { song: location.pathname.split('/').pop() });
})();
